module.exports = __webpack_public_path__ + "assets/ae4b86c9dd61f3068e7f6d9fa299f3b9.mp3";